/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: DataControlsTab.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/9 @ 1735
 * ---
 * Description:
 */

import {
  DataControlGroupTypes
}                                        from '../../../../common/controls/groups/data/data.controls';
import {
  Editor
}                                        from '../../../../store/observables/Editor';
import { ControlGroupView }              from '../../controls/ControlGroupView';
import { getDataControlGroup }           from '../../../../common/controls';
import { getShapeTypeFromId }            from '../../../../common/utils';
import { shapeTypesWithCustomDataPanel } from '../index';
import { ShapeTypes }                    from '../../../../common/enums';
import { RichTextTab }                   from '../richtext/RichTextTab';
import { ImageDataTab }                  from '../image/ImageDataTab';
import { TableTab }                      from '../table/TableTab';

interface Props {
  editor: Editor;
}

export const DataControlsTab = (props: Props) => {

  const renderControlGroups = () => {
    return Object.values(DataControlGroupTypes).map(it => {
      return <ControlGroupView editor={ props.editor }
                               controlGroup={ getDataControlGroup(it as DataControlGroupTypes,
                                 props.editor) }/>;
    });
  };

  const type = getShapeTypeFromId(props.editor.getSelectedShape()?.pamelaShape__nonObservable.id());

  // Render simple groups
  if (!shapeTypesWithCustomDataPanel.includes(type))
    return (
      <div>
        {
          renderControlGroups()
        }
      </div>
    );

  // Render complex data tabs
  switch (type) {
    case ShapeTypes.RICH_TEXT:
      return <RichTextTab editor={ props.editor }/>;
    case ShapeTypes.IMAGE:
      return <ImageDataTab editor={ props.editor }/>;
    case ShapeTypes.TABLE:
      return <TableTab editor={ props.editor }/>;
  }

  throw new Error('Undefined content for data tab');
};
